// @ts-strict
import { AnchorHTMLAttributes, ReactNode } from "react";

type ExternalLinkProps = {
  href: string;
  children: ReactNode;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "target" | "rel">;

/**
 * Canonical link to a URL outside the app. Always opens in a new tab with a
 * safe `rel="noopener noreferrer"`. Pass `className`, `onClick`, etc. through
 * as normal anchor props; provide any icon/content as children.
 */
const ExternalLink = ({ href, children, ...props }: ExternalLinkProps) => (
  <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
    {children}
  </a>
);

export default ExternalLink;
